<template>
  <div
    class="content-card"
    :class="[
      bgColor ? `content-card--bg-${bgColor}` : undefined,
      width ? `content-card--width-${width}` : undefined,
    ]"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  bgColor?: "dark" | "light" | "primary";
  width?: "lg" | "md" | "sm";
}>();
</script>

<style lang="postcss">
.content-card {
  @apply flex flex-col rounded-2xl py-6 gap-6;

  @screen 800 {
    @apply py-8;
  }

  &--bg-light {
    @apply bg-slate-50;
  }

  &--bg-dark {
    @apply bg-primary-100;
  }

  &--bg-primary {
    @apply bg-primary-700 text-white;
  }

  &--width-sm {
    @apply px-5;
  }

  &--width-md {
    @apply px-10;
  }

  &--width-lg {
    @apply px-16;
  }
}
</style>
